import React, {FC} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

import {H2} from "@irati/ui/src/Typography/Heading"
import {Label2 as Label} from "../Labels"
import Anchor from "../Link/styled/Anchor"
import Http404Svg from "./Http404.svg"

import {ErrorImg, ErrorWrapper} from "./styled/Http404"

interface Props extends InjectIntl {
  id?: string
}

const Http404: FC<Props> = (props) => {
  const idNamespace = id("Http404", props)
  const {formatMessage} = props

  return (
    <div id={idNamespace}>
      <ErrorWrapper id={id("wrapper", idNamespace)} direction="column" justifyContent="center" alignItems="center">
        <ErrorImg src={Http404Svg} alt="Error" />
        <H2 id={id("title", idNamespace)}>
          <FormattedMessage id="platform.http404.error.header" />
        </H2>
        <Label id={id("sub-title", idNamespace)}>
          <FormattedMessage
            id="platform.http404.error.subtitle"
            values={{
              url: (
                <Anchor href={formatMessage({id: "platform.http404.error.href.href"})} target="_BLANK">
                  <FormattedMessage id="platform.http404.error.href.text" />
                </Anchor>
              )
            }} />
        </Label>
      </ErrorWrapper>
    </div>
  )
}

Http404.defaultProps = {
  id: "http-404"
}

export default injectIntl(Http404)
